import React from "react"
import { EI18n, TI18nCtx } from "../common"

const defaultValue: TI18nCtx = {
  i18n: EI18n.en,
  setI18n: (_i18n: EI18n) => {},
}
export const I18nCtx = React.createContext<TI18nCtx>(defaultValue)
